import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { SearchService } from '@services/search.service';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import * as _ from 'lodash';
import { rotateInDownLeftOnEnterAnimation } from 'angular-animations';
@Component({
  selector: 'app-sphoto',
  templateUrl: './sphoto.component.html',
  styleUrls: ['./sphoto.component.sass'],
  animations: [
    rotateInDownLeftOnEnterAnimation({ anchor: 'searchPage' })
  ]
})
export class SphotoComponent implements OnInit {
  response: any = [];
  pageCounter = 1;
  totalRecord = 0;
  application = "photo";
  component = 'm';
  rows = 1;
  sort = '';
  searchtxt = "";
  params: any = [];
  total_record = 0;
  pageno = 1;
  dataLoding = true;
  constructor(private router: Router, private route: ActivatedRoute, private _searchService: SearchService, private _global: GlobalService) {
    this.rows = this._global.ROWS;
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    let p = {
      component: this.component,
      application: this.application,
      start: 0,
      sortOrder: 'desc',
      sortString: 'createdTime',
      rows: this.rows
    };
    this.route.queryParams.subscribe(params => {
      Object.entries(params).forEach(([key, value]) => {
        if (value) {
          p[key] = value;
        }
      });
    });

    this._searchService.application(p).subscribe(
      data => {
        this.dataLoding = false;
        this.params = this._global.getVal(data, 'request', '');
        this.response = data["response"]["docs"];
        this.total_record = this._global.getVal(data, 'response.numFound', '0');
      },
      error => {
        console.log("error", JSON.stringify(error));
      });

  }

  ngOnInit() {
    /* const queryParams = this.route.snapshot.queryParams
    const routeParams = this.route.snapshot.params; */
  }
  getSort(value) {
    this.dataLoding = true;
    this.response = [];
    let p = {
      component: this.component,
      application: this.application,
      start: 0,
      sortOrder: value,
      sortString: 'name',
      rows: this.rows
    };
    this._searchService.application(p).subscribe(
      data => {
        this.dataLoding = false;
        if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
          this.response = this.response.concat(data["response"]["docs"]);
          this.dataLoding = false;
          this.params = this._global.getVal(data, 'request', '');
        } else {
          this.dataLoding = false;
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  onScrollDown() {
    if (!this.dataLoding) {
      this.dataLoding = true;
      if (this.total_record <= this.pageCounter * this.rows) {
        this.dataLoding = false;
      } else {
        let p = this._global.generateParams(this.params, ['component', 'start', 'language', 'url', 'dialect']);
        p['start'] = this.pageCounter * this.rows;
        p['component'] = this.component;
        this._searchService.application(p).subscribe(
          data => {
            if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
              this.response = this.response.concat(data["response"]["docs"]);
              this.dataLoding = false;
              this.pageCounter += 1;
              this.params = this._global.getVal(data, 'request', '');
            } else {
              this.dataLoding = false;
            }
          },
          error => {
            console.log("error", JSON.stringify(error));
          });
        //  console.log('scrolled down!!', ev);

      }
    }
  }

  searchMedia(event: any) {
    this.dataLoding = true;
    this.response = [];
    let p = {
      component: this.component,
      application: this.application,
      start: 0,
      name: this.searchtxt,
      sortOrder: 'desc',
      sortString: 'createdTime',
      rows: this.rows
    };
    this._searchService.application(p).subscribe(
      data => {
        this.dataLoding = false;
        this.params = this._global.getVal(data, 'request', '');
        this.response = data["response"]["docs"];
        this.total_record = this._global.getVal(data, 'response.numFound', '0');
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
}
